import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import ContactUsSection from "../components/contact-us-section"
// import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Breadcrumb from "../components/breadcrumbs"

const NotFoundPage = ({location}) => (
  <Layout>
    <Seo title="404: Not found" />
    
    <div className='bg-primary'>
      <div className='container d-flex flex-column position-relative'>
        <div className='row justify-content-center'>
          <div className='col-lg-6 py-6'>
            <h1 className='text-white text-center'>404: Not Found</h1>
            <p className='text-white text-center'>You just hit a route that doesn&#39;t exist... the sadness.</p>
          </div>
        </div>
          
      </div>
    </div>

    <div className='py-6'>
      <ContactUsSection/>
    </div>
  </Layout>
)

export default NotFoundPage
